// eslint-disable-next-line vue/prefer-import-from-vue
import { isArray, isDate, isFunction, isMap, isObject, isSet, isSymbol } from '@vue/shared'

export function copy(object) {
    return object && typeof object === 'object' ? JSON.parse(JSON.stringify(object)) : object
}

export function clone(object) {
    return deepClone(object)
}

function deepClone(value, weakMap = new WeakMap()) {
    if (isDate(value)) return new Date(+value)

    if (isMap(value)) {
        const map = new Map()
        for (const item of value) map.set(deepClone(item[0], weakMap), deepClone(item[1], weakMap))
        return map
    }

    if (isSet(value)) {
        const set = new Set()
        for (const item of value) set.add(deepClone(item, weakMap))
        return set
    }

    if (isSymbol(value)) return Symbol(value.description)

    if (isFunction(value)) {
        return /^function|^\(\)/.test(value.toString())
            ? new Function(`return ${value.toString()}`)()
            : new Function(`return function ${value.toString()}`)()
    }

    if (!isObject(value)) return value

    const object = isArray(value) ? [] : Object.create(Object.getPrototypeOf(value))

    if (weakMap.has(value)) return weakMap.get(value)

    weakMap.set(value, object)
    for (const key of Object.keys(value)) object[key] = deepClone(value[key], weakMap)

    return object
}
